<template>
  <table width="100%">
    <tr>
      <td width="75%" class="date">
        <b-form-datepicker
          v-model="dateStr"
          :min="min"
          :start-weekday="MONDAY"
        />
      </td>
      <td width="25%">
        <time-input v-model="timeStr"/>
      </td>
    </tr>
  </table>
</template>

<script>
import { convertMomentToDataStr             } from '../../util.js';
import { convertMomentToTimeStr             } from '../../util.js';
import { convertDataStrAndTimeStrToUTC3Data } from '../../util.js';

import TimeInput from '../TimeInput.vue';

export default {
  name: 'MomentInputTable',

  components: {
    TimeInput
  },

  props: {
    // Date or String
    min: {},

    value: {
      type: Date,
      required: true,
    },
  },

  data() {    
    const moment = this.value;
    const timeStr = convertMomentToTimeStr(moment);
    const dateStr = convertMomentToDataStr(moment);

    return {
      MONDAY: 1,

      dateStr: dateStr,
      timeStr: timeStr,
    };
  },

  computed: {
    /** @returns {?Date} */
    moment() {
      return convertDataStrAndTimeStrToUTC3Data(this.dateStr, this.timeStr);
    },
  },

  watch: {
    dateStr() {
      this.emitInput();
    },

    timeStr() {
      this.emitInput();
    }
  },

  methods: {
    emitInput() {
      this.$emit('input', this.moment);
    }
  }
};
</script>

<style scoped>
td.date {
  padding-right: .2rem;
}
</style>
